import { Outlet, useLocation, useMatch } from "react-router-dom";
import Header from '../components/Header';
import Footer from '../components/Footer';
import React from "react";


const Layout = () => {
  const location = useLocation();
  const hideFooterRoutes = ["/404", "/thank-you" , "/demo-form"];
   const hideHeaderRoutes = ["/demo-form"];
  const shouldHideFooter = hideFooterRoutes.includes(location.pathname);
  const shouldHideHeader = hideHeaderRoutes.includes(location.pathname);
  const isHome = useMatch("/");

  return (
    <div className={isHome ? "overflow-correct" : ""}>
      {!shouldHideHeader && <Header />}
      <main>
        <Outlet />
      </main>
      {!shouldHideFooter && <Footer />}
    </div>
  );
};

export default Layout;
